/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'courses-2': {
    width: 463,
    height: 950,
    viewBox: '0 0 463 950',
    data: `<path pid="0" _fill="#FFF" fill-opacity=".3" d="M161.585.674C-79.922 283.443-46.473 708.452 236.295 949.96l.65-.76C-45.403 708.05-78.803 283.672 162.345 1.324l-.76-.65zm264.63 226.015C309.533 363.306 325.693 568.648 462.31 685.33l.65-.76c-136.199-116.324-152.309-321.034-35.986-457.231l-.76-.65z"/>`
  }
})
